import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { usePlayColumns } from "@/pages/plays/hooks/use-columns";
import { IPlayData } from "@/types/play";

export const PlaysList = () => {
  const columns = usePlayColumns();

  const table = useTable<IPlayData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      meta: { defaultQueryBy: "title,originalTitle" },
      sorters: { initial: [{ field: "title", order: "asc" }] },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="plays" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
